export class Events {
  public static readonly PointerUp = "pointerup";
  public static readonly PointerUpOutside = "pointerupoutside";
  public static readonly PointerMove = "pointermove";
  public static readonly PointerDown = "pointerdown";
  public static readonly Updated = "updated";
  public static readonly SelectionUpdated = "selectionupdated";
}
